/*** IMPORTS FROM imports-loader ***/
(function() {

(function (undefined) {
  "use strict";

  function Supervisor(sigInst, options) {
    var _this = this,
        workerFn = sigInst.getForceAtlas2Worker && sigInst.getForceAtlas2Worker();

    if (options = options || {}, _root.URL = _root.URL || _root.webkitURL, this.sigInst = sigInst, this.graph = this.sigInst.graph, this.ppn = 10, this.ppe = 3, this.config = {}, this.shouldUseWorker = options.worker !== !1 && webWorkers, this.workerUrl = options.workerUrl, this.started = !1, this.running = !1, this.shouldUseWorker) {
      if (this.workerUrl) this.worker = new Worker(this.workerUrl);else {
        var blob = this.makeBlob(workerFn);
        this.worker = new Worker(URL.createObjectURL(blob));
      }
      this.worker.postMessage = this.worker.webkitPostMessage || this.worker.postMessage;
    } else eval(workerFn);

    this.msgName = this.worker ? "message" : "newCoords", this.listener = function (t) {
      _this.nodesByteArray = new Float32Array(t.data.nodes), _this.running && (_this.applyLayoutChanges(), _this.sendByteArrayToWorker(), _this.sigInst.refresh());
    }, (this.worker || document).addEventListener(this.msgName, this.listener), this.graphToByteArrays(), sigInst.bind("kill", function () {
      sigInst.killForceAtlas2();
    });
  }

  if ("undefined" == typeof sigma) throw "sigma is not declared";

  var _root = this,
      webWorkers = ("Worker" in _root);

  Supervisor.prototype.makeBlob = function (t) {
    var e;

    try {
      e = new Blob([t], {
        type: "application/javascript"
      });
    } catch (s) {
      _root.BlobBuilder = _root.BlobBuilder || _root.WebKitBlobBuilder || _root.MozBlobBuilder, e = new BlobBuilder(), e.append(t), e = e.getBlob();
    }

    return e;
  }, Supervisor.prototype.graphToByteArrays = function () {
    var t,
        e,
        s,
        r = this.graph.nodes(),
        i = this.graph.edges(),
        o = r.length * this.ppn,
        n = i.length * this.ppe,
        a = {};

    for (this.nodesByteArray = new Float32Array(o), this.edgesByteArray = new Float32Array(n), t = e = 0, s = r.length; t < s; t++) {
      a[r[t].id] = e, this.nodesByteArray[e] = r[t].x, this.nodesByteArray[e + 1] = r[t].y, this.nodesByteArray[e + 2] = 0, this.nodesByteArray[e + 3] = 0, this.nodesByteArray[e + 4] = 0, this.nodesByteArray[e + 5] = 0, this.nodesByteArray[e + 6] = 1 + this.graph.degree(r[t].id), this.nodesByteArray[e + 7] = 1, this.nodesByteArray[e + 8] = r[t].size, this.nodesByteArray[e + 9] = 0, e += this.ppn;
    }

    for (t = e = 0, s = i.length; t < s; t++) {
      this.edgesByteArray[e] = a[i[t].source], this.edgesByteArray[e + 1] = a[i[t].target], this.edgesByteArray[e + 2] = i[t].weight || 0, e += this.ppe;
    }
  }, Supervisor.prototype.applyLayoutChanges = function () {
    for (var t = this.graph.nodes(), e = 0, s = 0, r = this.nodesByteArray.length; s < r; s += this.ppn) {
      t[e].x = this.nodesByteArray[s], t[e].y = this.nodesByteArray[s + 1], e++;
    }
  }, Supervisor.prototype.sendByteArrayToWorker = function (t) {
    var e = {
      action: t || "loop",
      nodes: this.nodesByteArray.buffer
    },
        s = [this.nodesByteArray.buffer];
    "start" === t && (e.config = this.config || {}, e.edges = this.edgesByteArray.buffer, s.push(this.edgesByteArray.buffer)), this.shouldUseWorker ? this.worker.postMessage(e, s) : _root.postMessage(e, "*");
  }, Supervisor.prototype.start = function () {
    if (!this.running) {
      this.running = !0;
      var t, e;

      for (t in this.sigInst.cameras) {
        e = this.sigInst.cameras[t], e.edgequadtree._enabled = !1;
      }

      this.started ? this.sendByteArrayToWorker() : (this.sendByteArrayToWorker("start"), this.started = !0);
    }
  }, Supervisor.prototype.stop = function () {
    if (this.running) {
      var t, e, s;

      for (t in this.sigInst.cameras) {
        e = this.sigInst.cameras[t], e.edgequadtree._enabled = !0, s = sigma.utils.getBoundaries(this.graph, e.readPrefix), e.settings("drawEdges") && e.settings("enableEdgeHovering") && e.edgequadtree.index(this.sigInst.graph, {
          prefix: e.readPrefix,
          bounds: {
            x: s.minX,
            y: s.minY,
            width: s.maxX - s.minX,
            height: s.maxY - s.minY
          }
        });
      }

      this.running = !1;
    }
  }, Supervisor.prototype.killWorker = function () {
    this.worker ? this.worker.terminate() : (_root.postMessage({
      action: "kill"
    }, "*"), document.removeEventListener(this.msgName, this.listener));
  }, Supervisor.prototype.configure = function (t) {
    if (this.config = t, this.started) {
      var e = {
        action: "config",
        config: this.config
      };
      this.shouldUseWorker ? this.worker.postMessage(e) : _root.postMessage(e, "*");
    }
  }, sigma.prototype.startForceAtlas2 = function (t) {
    return this.supervisor || (this.supervisor = new Supervisor(this, t)), t && this.supervisor.configure(t), this.supervisor.start(), this;
  }, sigma.prototype.stopForceAtlas2 = function () {
    return this.supervisor ? (this.supervisor.stop(), this) : this;
  }, sigma.prototype.killForceAtlas2 = function () {
    return this.supervisor ? (this.supervisor.stop(), this.supervisor.killWorker(), this.supervisor = null, this) : this;
  }, sigma.prototype.configForceAtlas2 = function (t) {
    return this.supervisor || (this.supervisor = new Supervisor(this, t)), this.supervisor.configure(t), this;
  }, sigma.prototype.isForceAtlas2Running = function (t) {
    return !!this.supervisor && this.supervisor.running;
  };
}).call(this), function (undefined) {
  "use strict";

  function no_crush(t) {
    var e,
        s,
        r,
        i = ["x", "y", "dx", "dy", "old_dx", "old_dy", "mass", "convergence", "size", "fixed"],
        o = ["source", "target", "weight"],
        n = ["node", "centerX", "centerY", "size", "nextSibling", "firstChild", "mass", "massCenterX", "massCenterY"];

    for (s = 0, r = n.length; s < r; s++) {
      e = new RegExp("rp\\(([^,]*), '" + n[s] + "'\\)", "g"), t = t.replace(e, 0 === s ? "$1" : "$1 + " + s);
    }

    for (s = 0, r = i.length; s < r; s++) {
      e = new RegExp("np\\(([^,]*), '" + i[s] + "'\\)", "g"), t = t.replace(e, 0 === s ? "$1" : "$1 + " + s);
    }

    for (s = 0, r = o.length; s < r; s++) {
      e = new RegExp("ep\\(([^,]*), '" + o[s] + "'\\)", "g"), t = t.replace(e, 0 === s ? "$1" : "$1 + " + s);
    }

    return t;
  }

  function getWorkerFn() {
    var t = crush ? crush(Worker.toString()) : Worker.toString();
    return ";(" + t + ").call(this);";
  }

  var _root = this,
      inWebWorker = !("document" in _root),
      Worker = function Worker(t) {
    function e() {
      var t,
          e,
          s = {},
          r = arguments.length;

      for (t = r - 1; t >= 0; t--) {
        for (e in arguments[t]) {
          s[e] = arguments[t][e];
        }
      }

      return s;
    }

    function s(t) {
      var e;

      for (e in t) {
        "hasOwnProperty" in t && !t.hasOwnProperty(e) || delete t[e];
      }

      return t;
    }

    function r(t, e, s) {
      s = s || {};
      a = t, h = e, u.nodesLength = a.length, u.edgesLength = h.length, i(s);
    }

    function i(t) {
      u.settings = e(t, u.settings);
    }

    function o() {
      var t, e, s, r, i, o, n, g, d, l, c, f, y, w, v;

      for (s = 0; s < u.nodesLength; s += u.ppn) {
        a[s + 4] = a[s + 2], a[s + 5] = a[s + 3], a[s + 2] = 0, a[s + 3] = 0;
      }

      if (u.settings.outboundAttractionDistribution) {
        for (d = 0, s = 0; s < u.nodesLength; s += u.ppn) {
          d += a[s + 6];
        }

        d /= u.nodesLength;
      }

      if (u.settings.barnesHutOptimize) {
        var k,
            m,
            b = 1 / 0,
            M = -(1 / 0),
            A = 1 / 0,
            B = -(1 / 0);

        for (p = [], s = 0; s < u.nodesLength; s += u.ppn) {
          b = Math.min(b, a[s]), M = Math.max(M, a[s]), A = Math.min(A, a[s + 1]), B = Math.max(B, a[s + 1]);
        }

        for (p[0] = -1, p[1] = (b + M) / 2, p[2] = (A + B) / 2, p[3] = Math.max(M - b, B - A), p[4] = -1, p[5] = -1, p[6] = 0, p[7] = 0, p[8] = 0, t = 1, s = 0; s < u.nodesLength; s += u.ppn) {
          for (e = 0;;) {
            if (p[e + 5] >= 0) k = a[s] < p[e + 1] ? a[s + 1] < p[e + 2] ? p[e + 5] : p[e + 5] + u.ppr : a[s + 1] < p[e + 2] ? p[e + 5] + 2 * u.ppr : p[e + 5] + 3 * u.ppr, p[e + 7] = (p[e + 7] * p[e + 6] + a[s] * a[s + 6]) / (p[e + 6] + a[s + 6]), p[e + 8] = (p[e + 8] * p[e + 6] + a[s + 1] * a[s + 6]) / (p[e + 6] + a[s + 6]), p[e + 6] += a[s + 6], e = k;else {
              if (p[e] < 0) {
                p[e] = s;
                break;
              }

              if (p[e + 5] = t * u.ppr, n = p[e + 3] / 2, g = p[e + 5], p[g] = -1, p[g + 1] = p[e + 1] - n, p[g + 2] = p[e + 2] - n, p[g + 3] = n, p[g + 4] = g + u.ppr, p[g + 5] = -1, p[g + 6] = 0, p[g + 7] = 0, p[g + 8] = 0, g += u.ppr, p[g] = -1, p[g + 1] = p[e + 1] - n, p[g + 2] = p[e + 2] + n, p[g + 3] = n, p[g + 4] = g + u.ppr, p[g + 5] = -1, p[g + 6] = 0, p[g + 7] = 0, p[g + 8] = 0, g += u.ppr, p[g] = -1, p[g + 1] = p[e + 1] + n, p[g + 2] = p[e + 2] - n, p[g + 3] = n, p[g + 4] = g + u.ppr, p[g + 5] = -1, p[g + 6] = 0, p[g + 7] = 0, p[g + 8] = 0, g += u.ppr, p[g] = -1, p[g + 1] = p[e + 1] + n, p[g + 2] = p[e + 2] + n, p[g + 3] = n, p[g + 4] = p[e + 4], p[g + 5] = -1, p[g + 6] = 0, p[g + 7] = 0, p[g + 8] = 0, t += 4, k = a[p[e]] < p[e + 1] ? a[p[e] + 1] < p[e + 2] ? p[e + 5] : p[e + 5] + u.ppr : a[p[e] + 1] < p[e + 2] ? p[e + 5] + 2 * u.ppr : p[e + 5] + 3 * u.ppr, p[e + 6] = a[p[e] + 6], p[e + 7] = a[p[e]], p[e + 8] = a[p[e] + 1], p[k] = p[e], p[e] = -1, m = a[s] < p[e + 1] ? a[s + 1] < p[e + 2] ? p[e + 5] : p[e + 5] + u.ppr : a[s + 1] < p[e + 2] ? p[e + 5] + 2 * u.ppr : p[e + 5] + 3 * u.ppr, k !== m) {
                p[m] = s;
                break;
              }

              e = k;
            }
          }
        }
      }

      if (u.settings.barnesHutOptimize) for (l = u.settings.scalingRatio, s = 0; s < u.nodesLength; s += u.ppn) {
        for (e = 0;;) {
          if (p[e + 5] >= 0) {
            if (w = Math.sqrt(Math.pow(a[s] - p[e + 7], 2) + Math.pow(a[s + 1] - p[e + 8], 2)), 2 * p[e + 3] / w < u.settings.barnesHutTheta) {
              if (c = a[s] - p[e + 7], f = a[s + 1] - p[e + 8], u.settings.adjustSizes ? w > 0 ? (v = l * a[s + 6] * p[e + 6] / w / w, a[s + 2] += c * v, a[s + 3] += f * v) : w < 0 && (v = -l * a[s + 6] * p[e + 6] / w, a[s + 2] += c * v, a[s + 3] += f * v) : w > 0 && (v = l * a[s + 6] * p[e + 6] / w / w, a[s + 2] += c * v, a[s + 3] += f * v), p[e + 4] < 0) break;
              e = p[e + 4];
              continue;
            }

            e = p[e + 5];
          } else {
            if (p[e] >= 0 && p[e] !== s && (c = a[s] - a[p[e]], f = a[s + 1] - a[p[e] + 1], w = Math.sqrt(c * c + f * f), u.settings.adjustSizes ? w > 0 ? (v = l * a[s + 6] * a[p[e] + 6] / w / w, a[s + 2] += c * v, a[s + 3] += f * v) : w < 0 && (v = -l * a[s + 6] * a[p[e] + 6] / w, a[s + 2] += c * v, a[s + 3] += f * v) : w > 0 && (v = l * a[s + 6] * a[p[e] + 6] / w / w, a[s + 2] += c * v, a[s + 3] += f * v)), p[e + 4] < 0) break;
            e = p[e + 4];
          }
        }
      } else for (l = u.settings.scalingRatio, r = 0; r < u.nodesLength; r += u.ppn) {
        for (i = 0; i < r; i += u.ppn) {
          c = a[r] - a[i], f = a[r + 1] - a[i + 1], u.settings.adjustSizes ? (w = Math.sqrt(c * c + f * f) - a[r + 8] - a[i + 8], w > 0 ? (v = l * a[r + 6] * a[i + 6] / w / w, a[r + 2] += c * v, a[r + 3] += f * v, a[i + 2] += c * v, a[i + 3] += f * v) : w < 0 && (v = 100 * l * a[r + 6] * a[i + 6], a[r + 2] += c * v, a[r + 3] += f * v, a[i + 2] -= c * v, a[i + 3] -= f * v)) : (w = Math.sqrt(c * c + f * f), w > 0 && (v = l * a[r + 6] * a[i + 6] / w / w, a[r + 2] += c * v, a[r + 3] += f * v, a[i + 2] -= c * v, a[i + 3] -= f * v));
        }
      }

      for (g = u.settings.gravity / u.settings.scalingRatio, l = u.settings.scalingRatio, s = 0; s < u.nodesLength; s += u.ppn) {
        v = 0, c = a[s], f = a[s + 1], w = Math.sqrt(Math.pow(c, 2) + Math.pow(f, 2)), u.settings.strongGravityMode ? w > 0 && (v = l * a[s + 6] * g) : w > 0 && (v = l * a[s + 6] * g / w), a[s + 2] -= c * v, a[s + 3] -= f * v;
      }

      for (l = 1 * (u.settings.outboundAttractionDistribution ? d : 1), o = 0; o < u.edgesLength; o += u.ppe) {
        r = h[o], i = h[o + 1], n = h[o + 2], y = Math.pow(n, u.settings.edgeWeightInfluence), c = a[r] - a[i], f = a[r + 1] - a[i + 1], u.settings.adjustSizes ? (w = Math.sqrt(Math.pow(c, 2) + Math.pow(f, 2) - a[r + 8] - a[i + 8]), u.settings.linLogMode ? u.settings.outboundAttractionDistribution ? w > 0 && (v = -l * y * Math.log(1 + w) / w / a[r + 6]) : w > 0 && (v = -l * y * Math.log(1 + w) / w) : u.settings.outboundAttractionDistribution ? w > 0 && (v = -l * y / a[r + 6]) : w > 0 && (v = -l * y)) : (w = Math.sqrt(Math.pow(c, 2) + Math.pow(f, 2)), u.settings.linLogMode ? u.settings.outboundAttractionDistribution ? w > 0 && (v = -l * y * Math.log(1 + w) / w / a[r + 6]) : w > 0 && (v = -l * y * Math.log(1 + w) / w) : u.settings.outboundAttractionDistribution ? (w = 1, v = -l * y / a[r + 6]) : (w = 1, v = -l * y)), w > 0 && (a[r + 2] += c * v, a[r + 3] += f * v, a[i + 2] -= c * v, a[i + 3] -= f * v);
      }

      var W, L, F, _;

      if (u.settings.adjustSizes) for (s = 0; s < u.nodesLength; s += u.ppn) {
        a[s + 9] || (W = Math.sqrt(Math.pow(a[s + 2], 2) + Math.pow(a[s + 3], 2)), W > u.maxForce && (a[s + 2] = a[s + 2] * u.maxForce / W, a[s + 3] = a[s + 3] * u.maxForce / W), L = a[s + 6] * Math.sqrt((a[s + 4] - a[s + 2]) * (a[s + 4] - a[s + 2]) + (a[s + 5] - a[s + 3]) * (a[s + 5] - a[s + 3])), F = Math.sqrt((a[s + 4] + a[s + 2]) * (a[s + 4] + a[s + 2]) + (a[s + 5] + a[s + 3]) * (a[s + 5] + a[s + 3])) / 2, _ = .1 * Math.log(1 + F) / (1 + Math.sqrt(L)), a[s] = a[s] + a[s + 2] * (_ / u.settings.slowDown), a[s + 1] = a[s + 1] + a[s + 3] * (_ / u.settings.slowDown));
      } else for (s = 0; s < u.nodesLength; s += u.ppn) {
        a[s + 9] || (L = a[s + 6] * Math.sqrt((a[s + 4] - a[s + 2]) * (a[s + 4] - a[s + 2]) + (a[s + 5] - a[s + 3]) * (a[s + 5] - a[s + 3])), F = Math.sqrt((a[s + 4] + a[s + 2]) * (a[s + 4] + a[s + 2]) + (a[s + 5] + a[s + 3]) * (a[s + 5] + a[s + 3])) / 2, _ = a[s + 7] * Math.log(1 + F) / (1 + Math.sqrt(L)), a[s + 7] = Math.min(1, Math.sqrt(_ * (Math.pow(a[s + 2], 2) + Math.pow(a[s + 3], 2)) / (1 + Math.sqrt(L)))), a[s] = a[s] + a[s + 2] * (_ / u.settings.slowDown), a[s + 1] = a[s + 1] + a[s + 3] * (_ / u.settings.slowDown));
      }
      u.iterations++;
    }

    function n(t) {
      for (var e = 0; e < t; e++) {
        o();
      }

      g();
    }

    var a,
        h,
        p,
        g,
        u = {
      ppn: 10,
      ppe: 3,
      ppr: 9,
      maxForce: 10,
      iterations: 0,
      converged: !1,
      settings: {
        linLogMode: !1,
        outboundAttractionDistribution: !1,
        adjustSizes: !1,
        edgeWeightInfluence: 0,
        scalingRatio: 1,
        strongGravityMode: !1,
        gravity: 1,
        slowDown: 1,
        barnesHutOptimize: !1,
        barnesHutTheta: .5,
        startingIterations: 1,
        iterationsPerRender: 1
      }
    };
    g = "undefined" != typeof window && window.document ? function () {
      var t;
      document.createEvent ? (t = document.createEvent("Event"), t.initEvent("newCoords", !0, !1)) : (t = document.createEventObject(), t.eventType = "newCoords"), t.eventName = "newCoords", t.data = {
        nodes: a.buffer
      }, requestAnimationFrame(function () {
        document.dispatchEvent(t);
      });
    } : function () {
      self.postMessage({
        nodes: a.buffer
      }, [a.buffer]);
    };

    var d = function d(t) {
      switch (t.data.action) {
        case "start":
          r(new Float32Array(t.data.nodes), new Float32Array(t.data.edges), t.data.config), n(u.settings.startingIterations);
          break;

        case "loop":
          a = new Float32Array(t.data.nodes), n(u.settings.iterationsPerRender);
          break;

        case "config":
          i(t.data.config);
          break;

        case "kill":
          s(u), a = null, h = null, p = null, self.removeEventListener("message", d);
      }
    };

    self.addEventListener("message", d);
  },
      crush = null;

  if (inWebWorker) eval(getWorkerFn());else {
    if ("undefined" == typeof sigma) throw "sigma is not declared";
    sigma.prototype.getForceAtlas2Worker = getWorkerFn;
  }
}.call(this);
}.call(window));